"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var uuid_1 = require("uuid");
var endpoint_1 = require("./endpoint");
var isBrowser = typeof window !== 'undefined';
var storage = {
    store: {},
    getItem: function (key) {
        return storage[key];
    },
    setItem: function (key, value) {
        storage[key] = value;
    },
};
// tslint:disable-next-line:max-classes-per-file
var Medusa = /** @class */ (function (_super) {
    __extends(Medusa, _super);
    function Medusa(stage) {
        var _this = _super.call(this, stage, 'medusa') || this;
        _this.storage = isBrowser ? window.localStorage : storage;
        return _this;
    }
    Medusa.prototype.generateUUID = function () {
        var id = this.storage.getItem('bea-id');
        if (id) {
            return id;
        }
        var uuid = uuid_1.v4();
        this.storage.setItem('bea-id', uuid);
        return uuid;
    };
    // post profile/likes profile/shares profile/views
    // get profiles/id
    // search through all available cruises
    // get details for a specific profile
    Medusa.prototype.profile = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/profiles/{id}';
                query = {};
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    Medusa.prototype.setLikes = function (id, likes) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/profile/likes/{id}';
                body = {
                    id: id,
                    likes: likes,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Medusa.prototype.setViews = function (id, views) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/profile/views/{id}';
                body = {
                    id: id,
                    views: views,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Medusa.prototype.setShares = function (id, shares) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { id: id };
                pathTemplate = '/profile/shares/{id}';
                body = {
                    id: id,
                    shares: shares,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Medusa.prototype.trackBookingInterest = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var pathTemplate;
            return __generator(this, function (_a) {
                pathTemplate = '/booking/interest';
                return [2 /*return*/, this.invokePOST(null, pathTemplate, data)];
            });
        });
    };
    Medusa.prototype.trackBookingSuccess = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var pathTemplate;
            return __generator(this, function (_a) {
                pathTemplate = '/booking/checkout';
                return [2 /*return*/, this.invokePOST(null, pathTemplate, data)];
            });
        });
    };
    Medusa.prototype.logInteraction = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var pathTemplate;
            return __generator(this, function (_a) {
                if (!isBrowser) {
                    return [2 /*return*/];
                }
                pathTemplate = '/interaction';
                return [2 /*return*/, this.invokePOST(null, pathTemplate, {
                        session: this.generateUUID(),
                        message: data,
                    })];
            });
        });
    };
    Medusa.prototype.logPerformance = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var pathTemplate;
            return __generator(this, function (_a) {
                if (!isBrowser) {
                    return [2 /*return*/];
                }
                pathTemplate = '/performance';
                return [2 /*return*/, this.invokePOST(null, pathTemplate, {
                        session: this.generateUUID(),
                        message: data,
                    })];
            });
        });
    };
    Medusa.prototype.logError = function (code, data) {
        return __awaiter(this, void 0, void 0, function () {
            var pathTemplate;
            return __generator(this, function (_a) {
                if (!isBrowser) {
                    return [2 /*return*/];
                }
                pathTemplate = '/error';
                return [2 /*return*/, this.invokePOST(null, pathTemplate, {
                        session: this.generateUUID(),
                        message: data,
                        code: code,
                        store: lodash_1.get(window, '$store.state.route', undefined),
                    })];
            });
        });
    };
    return Medusa;
}(endpoint_1.Endpoint));
exports.default = Medusa;
//# sourceMappingURL=medusa.js.map